import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
//import imgA from "../img/engshinwon.png";
import imgA from "../img/small.jpg";
const useStyles = makeStyles({
  registerbox: {
    height: "14%",
    paddingTop: "5%",
    paddingBottom: "2%",
  },
  registerlogo: {
    textAlign: "center",
    marginBottom: 10,
    backgroundColor: "white",
  },
  registerText: {
    color: "black",
    fontSize: "calc(10px + 2vmin)",
    fontWeight: "bold",
    textAlign: "center",
  },
  "@media screen and (min-width:600px)": {
    registerbox: {
      paddingTop: 40,
    },
  },
});
function Header({ title }) {
  const classes = useStyles();
  return (
    <Fragment>
      <div className={classes.registerbox}>
        <div className={classes.registerlogo}>
          <img src={imgA} alt="신원로고" />
        </div>
        <div className={classes.registerText}>{title}</div>
      </div>
    </Fragment>
  );
}

export default Header;
